import useIntercomFinAIAgentWidget, {
  useIsIntercomFinAIEnabled,
} from './useIntercomFinAIAgentWidget'

const IntercomFinAIAgent = () => {
  const { loadIntercomFinAIAgent } = useIntercomFinAIAgentWidget()
  const isFinAIExperimentEnabled = useIsIntercomFinAIEnabled()

  if (isFinAIExperimentEnabled) {
    loadIntercomFinAIAgent()
  }

  return null
}

export default IntercomFinAIAgent
